// @flow
import * as React from 'react';
import {StyleSheet, View, TouchableWithoutFeedback} from 'react-native';
import Swiper from 'react-native-swiper';

import {FullButton, TertiaryFullButton} from '../../../components/common';
import theme from '../../../theme-config';

import type {
  NavigationRoute,
  NavigationScreenProp,
} from '@react-navigation/compat';

class Carousel extends React.PureComponent<PropsType, StateType> {
  swiper: any;
  styles = getStyles();
  state = {
    currentPage: 0,
  };

  _renderBullets = () => {
    const children =
      this.props.children === undefined ? [] : this.props.children;
    const styles = this.styles;
    const pageLength = children.length;
    const bullets = [];
    for (let i = 0; i < pageLength; i += 1) {
      bullets.push(
        <TouchableWithoutFeedback
          onPress={() => this.animateToPage(i)}
          key={`bullet${i}`}>
          <View
            style={[
              styles.bullet,
              i === this.state.currentPage && styles.chosenBullet,
            ]}
          />
        </TouchableWithoutFeedback>,
      );
    }
    return (
      <View style={styles.bullets} pointerEvents="box-none">
        <View style={styles.bulletsContainer} pointerEvents="box-none">
          {bullets}
        </View>
      </View>
    );
  };

  animateToPage = (targetPage: number) =>
    this.swiper.scrollBy(targetPage - this.state.currentPage);

  setCurrentPage = (currentPage: number) => this.setState({currentPage});

  render() {
    const styles = this.styles;
    const children =
      this.props.children === undefined ? [] : this.props.children;
    const childrenLength = children.length;
    const lastScreen = this.state.currentPage >= childrenLength - 1;

    return (
      <View style={this.props.style}>
        <Swiper
          ref={(ref: any) => (this.swiper = ref)}
          alwaysBounceHorizontal={false}
          alwaysBounceVertical={false}
          contentInset={{top: 0}}
          automaticallyAdjustContentInsets={false}
          showsHorizontalScrollIndicator={false}
          horizontal
          pagingEnabled
          bounces={false}
          index={this.state.currentPage}
          onIndexChanged={this.setCurrentPage}
          loop={false}
          showsPagination={false}
          showsButtons={false}
          testID={this.props.testID}>
          {children}
        </Swiper>
        {!lastScreen && (
          <View style={styles.navButtonContainer}>
            <TertiaryFullButton
              text={this.props.skipLabel}
              onPress={this.props.onSkip}
              style={styles.skipButton}
              testID={'skipButton'}
            />
          </View>
        )}
        <View style={styles.footerContainer}>
          {lastScreen ? (
            <FullButton
              text={this.props.labelDone}
              onPress={this.props.onSkip}
              style={styles.endButton}
              isNotLoadingTestID="onboardingDoneButton"
            />
          ) : (
            this._renderBullets()
          )}
        </View>
      </View>
    );
  }
}

type PropsType = {
  children: any,
  labelDone: string,
  navigation: NavigationScreenProp<NavigationRoute>,
  onSkip: Function,
  skipLabel: string,
  style: any,
  testID?: string,
};

type StateType = {
  currentPage: number,
};

type DefaultProps = {
  children: any,
};

const getStyles = () =>
  StyleSheet.create({
    footerContainer: {
      alignItems: 'center',
      bottom: 55,
      backgroundColor: 'transparent',
      position: 'absolute',
      left: 0,
      right: 0,
    },
    bullets: {
      height: 30,
      backgroundColor: 'transparent',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'row',
    },
    bulletsContainer: {
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'row',
    },
    chosenBullet: {
      backgroundColor: theme.onboarding.chosenBulletColor,
      borderColor: theme.onboarding.chosenBulletColor,
    },
    bullet: {
      margin: 5,
      width: 8,
      height: 8,
      borderRadius: 20,
      backgroundColor: 'transparent',
      borderColor: theme.onboarding.bulletPointColor,
      borderWidth: 1,
    },
    navButtonContainer: {
      position: 'absolute',
      top: 0,
      right: 0,
    },
    skipButton: {
      marginVertical: 20,
      marginHorizontal: 20,
      paddingHorizontal: 10,
    },
    endButton: {
      width: 250,
    },
  });

export default Carousel;
